import type { TuningTelemetryWindow } from '../contracts/measurements';
import { tuningJsonBytes } from '../contracts/validation';

/** Holds only bounded summary records: 30 seconds before a trigger and 10 after. */
export class TelemetryIncidentRing {
  private records: { window: TuningTelemetryWindow; bytes: number }[] = [];
  private bytes = 0;
  private triggerMs: number | undefined;
  private dropped = 0;
  constructor(private readonly maxBytes = 2 * 1_024 * 1_024 - 1) {}
  append(window: TuningTelemetryWindow): void {
    const bytes = tuningJsonBytes(window);
    if (!Number.isFinite(bytes) || bytes > this.maxBytes) { this.dropped++; return; }
    const copy = JSON.parse(JSON.stringify(window)) as TuningTelemetryWindow;
    this.records.push({ window: copy, bytes }); this.bytes += bytes;
    const end = window.monotonicEndMs;
    const earliest = this.triggerMs === undefined ? end - 30_000 : Math.max(end - 40_000, this.triggerMs - 30_000);
    while (this.records.length && (this.bytes > this.maxBytes || this.records[0].window.monotonicEndMs < earliest)) this.evict();
    if (this.triggerMs !== undefined && end > this.triggerMs + 10_000) this.triggerMs = undefined;
  }
  trigger(monotonicMs: number): void { this.triggerMs ??= monotonicMs; }
  snapshot(): { windows: readonly TuningTelemetryWindow[]; retainedBytes: number; dropped: number } {
    return { windows: this.records.map(({ window }) => JSON.parse(JSON.stringify(window)) as TuningTelemetryWindow),
      retainedBytes: this.bytes, dropped: this.dropped };
  }
  reset(): void { this.records = []; this.bytes = 0; this.triggerMs = undefined; this.dropped = 0; }
  private evict(): void { const record = this.records.shift(); if (record) { this.bytes -= record.bytes; this.dropped++; } }
}
